export interface Dashboard {
    data: any;
    name: string;
}
